module.exports = __webpack_public_path__ + "static/media/promo_discount.3f5042e9.svg";